import { MenuItem } from "@mui/material";
import closeDropdownIcon from "../../assets/images/bitmaps/close_mobile_dropdown.png";
import style from "./MobileDropDown.module.css";
import FormHelperText from "@mui/material/FormHelperText";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
interface MobileDropDownPropsDI {
  items: Array<{ value: number | string; text: string }>;
  value: number | string | Array<string | number> | null;
  id?: string;
  labelId?: string;
  errorString?: string;
  hasError?: boolean;
  open?: boolean;
  title?: string;
  onClick?: React.MouseEventHandler<HTMLLIElement>;
  onChange?: (
    event: React.ChangeEvent<{ name?: string; value: any }>,
    child: React.ReactNode
  ) => void;
  changeOpen?: () => void;
}

const MobileDropDown: React.FC<MobileDropDownPropsDI> = (props) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const handleDropDownResize = (swipeableRef: any) => {
    if (
      swipeableRef &&
      swipeableRef.current &&
      swipeableRef.current.parentElement
    ) {
      if (swipeableRef.current.clientHeight >= window.innerHeight) {
        swipeableRef.current.parentElement.parentElement.style.borderRadius =
          "0";
      } else {
        swipeableRef.current.parentElement.parentElement.style.borderRadius =
          "20px 20px 0 0";
      }
    }
  };

  return (
    <React.Fragment>
      <div className={style.MobileDropDown__wrapper}>
        <div
          className={style.dropdown_header}
          ref={dropdownRef}
          onLoad={() => handleDropDownResize(dropdownRef)}
        >
          <h4>{props.title}</h4>
          <button>
            <img
              src={closeDropdownIcon}
              alt={t("Dropdown-Close-alt")}
              onClick={props.changeOpen}
            />
          </button>
        </div>
        <ul>
          {props.items.map((item, i) => {
            return (
              <MenuItem
                key={i}
                tabIndex={0}
                className={
                  style.select__item +
                  " " +
                  (props.value === String(item.value)
                    ? style.select__itemSelected
                    : "")
                }
                value={item.value}
                onClick={props.onClick}
              >
                {item.text}
              </MenuItem>
            );
          })}
        </ul>
        <FormHelperText className={style.error}>
          {props.hasError && props.errorString}
        </FormHelperText>
      </div>
    </React.Fragment>
  );
};
export default MobileDropDown;
